import { render } from "./OrderFilesModal.vue?vue&type=template&id=4e3328e4&scoped=true"
import script from "./OrderFilesModal.vue?vue&type=script&lang=js"
export * from "./OrderFilesModal.vue?vue&type=script&lang=js"

import "./OrderFilesModal.vue?vue&type=style&index=0&id=4e3328e4&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e3328e4"]])

export default __exports__